import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import appReducer from './routes/reducer';
import { reducer as formReducer } from 'redux-form';

export const RESET_APP = 'RESET_APP';

export function resetApp() {
  return {
    type: RESET_APP
  };
}

const allReducers = combineReducers({
  routing: routerReducer,
  app: appReducer,
  form: formReducer
});

function rootReducer(state, action) {
  if (action.type === RESET_APP) {
    state = undefined;
  }

  return allReducers(state, action);
}

export default rootReducer;
